module.exports = __webpack_public_path__ + "static/media/undraw_tabs_jf82.ddd6be09.svg";